import {Translation} from "react-i18next";

const ConfigSelectCalculation = [
    {
        id : "OTHER" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.other")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_SUNDAY" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subSunday")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_SATURDAY" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subSaturday")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_SATURDAY_SUNDAY" ,
        type :(
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subSaturdaySunday")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_HALF_SATURDAY_AND_SUNDAY" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subHalfSaturdayAndSunday")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_HALF_SATURDAY_SUNDAY" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subHalfSaturdaySunday")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_SATURDAY_HALF_SUNDAY" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subSaturdayHalfSunday")}</span>}
            </Translation>
        )
    },
    {
        id : "SUB_HALF_N_DAY" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.subHalfNDay")}</span>}
            </Translation>
        )
    },
    {
        id : "TOTAL_SHIFT" ,
        type : (
            <Translation>
                {(t, { i18n }) => <span>{t("typeArray.totalShift")}</span>}
            </Translation>
        )
    },


]

export default ConfigSelectCalculation